var $countrySelector,
  $typeTargets,
  $typeSelector,
  $amountTargets,
  $containerRow,
  $backButton,
  $openComparePopup,
  $comparePopup,
  $closeComparePopup;


$(document).ready(function($) {
  $countrySelector = $('.js-country-selector');
  $typeTargets = $('.js-type-target');
  $typeSelector = $('.js-type-selector');
  $amountTargets = $('.js-amount-target');
  $containerRow = $('.js-cost-row');
  $backButton = $('.js-back');
  $openComparePopup = $('.js-open-compare-popup');
  $comparePopup = $('.js-compare-popup');
  $closeComparePopup = $('.js-close-compare-popup');

  // Events
  $openComparePopup.on('click', function(e) {
    e.preventDefault();

    $comparePopup.addClass('is-open').appendTo($body);
  });

  $closeComparePopup.on('click', function(e) {
    e.preventDefault();

    $comparePopup.removeClass('is-open');
  });


  var panel;
  $backButton.on('click', function() {
    panel = $containerRow.attr('data-page');
    panel = parseInt(panel) - 1;
    if (panel < 1) {
      panel = 1;
    }

    $amountTargets.removeClass('is-open');
    if (panel === 1) {
      $typeTargets.removeClass('is-open');
      $countrySelector.removeClass('is-open');
    }

    if (panel === 2) {
      $typeSelector.removeClass('is-open');
    }
    $containerRow.attr('data-page', panel);
  });



  $countrySelector.on('click', function(e) {
    e.preventDefault();

    // Skip if we click the same item
    if ($(this).hasClass('is-open')) {
      return;
    }

    $containerRow.attr('data-page', '2');

    $countrySelector.removeClass('is-open');  // Remove class on all selectors
    $(this).addClass('is-open');              // Add 'is-open' on selected selector

    var targetIndex = $(this).data('target');
    var $target = $('.js-type-target[data-index='+ targetIndex+']');
    $typeTargets.removeClass('is-open');
    $amountTargets.removeClass('is-open');
    $target.addClass('is-open');
  });

  $typeSelector.on('click', function(e) {
    e.preventDefault();

    // Skip if we click the same item
    if ($(this).hasClass('is-open')) {
      return;
    }

    $containerRow.attr('data-page', '3');

    $typeSelector.removeClass('is-open');  // Remove class on all selectors
    $(this).addClass('is-open');           // Add 'is-open' on selected selector

    var targetIndex = $(this).data('target');
    var $target = $('.js-amount-target[data-index='+ targetIndex+']');
    $amountTargets.removeClass('is-open');
    $target.addClass('is-open');

  });
});


// Functions
